import React from 'react';
import { motion } from 'framer-motion';
const situations = [{
  emoji: '😩',
  title: 'Agotamiento por diseño',
  desc: 'Horas armando guías en Canva o Word que podrían estar listas en segundos.'
}, {
  emoji: '🐢',
  title: 'Baja adherencia del paciente',
  desc: 'Sin material claro, el paciente abandona el protocolo a los pocos días.'
}, {
  emoji: '⏰',
  title: 'Sin sistema, sin estándar',
  desc: 'Improvisás en cada consulta y tu consultorio nunca termina de profesionalizarse.'
}, {
  emoji: '😟',
  title: 'Percepción de valor baja',
  desc: 'Sin materiales de élite que respalden tu trabajo, cuesta justificar mejores honorarios.'
}];
export function ProblemSection() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-147">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-148">
        <div className="text-center mb-10" data-id="element-149">
          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-4 text-slate-900" data-id="element-150">
            ¿TE RESULTA FAMILIAR ESTA SITUACIÓN?
          </h2>
          <p className="text-xl font-semibold text-emerald-700 mb-4" data-id="element-151">
            ¿Perdés horas preparando materiales para tus pacientes?
          </p>
          <p className="text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-152">
            Si sos nutricionista o profesional de la salud, probablemente esto
            te pase todos los días.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-153">
          {situations.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-50 p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-emerald-100 transition-colors" data-id="element-154">
              <div className="text-3xl mb-3" data-id="element-155">{item.emoji}</div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-156">
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed text-sm" data-id="element-157">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}